type Params = Record<string, unknown>;

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

const isProduction =
  typeof window !== "undefined" &&
  !["localhost", "staging.ghibgen.com"].includes(window.location.hostname);

export function trackEvent(eventName: string, params: Params = {}) {
  if (!isProduction) return;
  const enriched = { ...params, timestamp: new Date().toISOString() };
  window.dataLayer?.push({ event: eventName, event_id: crypto.randomUUID(), ...enriched });
}
